export const allLangauges = {
  "C/C++": "c_cpp",
  Python: "python",
  Java: "java",
  JavaScript: "javascript",
  Kotlin: "kotlin",
  Rust: "rust",
};
